import AddXSDMessageModal from './AddXSDMessageModal';

export default AddXSDMessageModal;
